export default __webpack_public_path__ + "static/media/sfi-box.e904bbac.svg";